// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MDpmocuTEj-8wR {\n  color: #5e6c84;\n  display: block;\n  margin: 35px auto;\n  text-align: center;\n  max-width: 600px;\n}\n.MDpmocuTEj-8wR h1 {\n  font-size: 26px;\n  margin-top: 20px;\n  margin-bottom: 24px;\n}\n.MDpmocuTEj-8wR p {\n  font-size: 18px;\n  line-height: 22px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": "MDpmocuTEj-8wR"
};
export default ___CSS_LOADER_EXPORT___;
